// src/api/questionnaires.js
import { api } from "../lib/apiClient";

// Récupérer les questions du questionnaire valeurs
export async function getValuesSurvey() {
  const { data } = await api.get("/ciaov2_values_survey");
  return data;
}

// Récupérer les réponses existantes de l'utilisateur
export async function getUserAnswers() {
  const { data } = await api.get("/ciaov2_values_survey_user");
  return data;
}

// Récupérer le résultat du questionnaire (null si pas terminé)
export async function getUserResult() {
  const { data } = await api.get("/ciaov2_values_survey_user_result");
  return data;
}

// Créer une nouvelle réponse
export async function createUserAnswer({ ciaov2_user_id, ciaov2_values_survey_id, answer }) {
  const { data } = await api.post("/ciaov2_values_survey_user", {
    ciaov2_user_id,
    ciaov2_values_survey_id,
    answer
  });
  return data;
}

// Mettre à jour une réponse existante
export async function updateUserAnswer(id, answer) {
  const { data } = await api.patch(`/ciaov2_values_survey_user/${id}`, {
    answer
  });
  return data;
}

// Créer le résultat du questionnaire (calcul des scores)
export async function createUserResult() {
  const { data } = await api.post("/ciaov2_values_survey_user_result");
  return data;
}

// Générer la synthèse IA du résultat
export async function generateSynthesis() {
  const { data } = await api.post("/ciaov2_values_survey_user_result/synthesis");
  return data;
}

// Envoyer l'accord de partage aux parents (Valeurs)
export async function sendValuesAgreement() {
  const { data } = await api.post("/ciaov2_values_survey_user_result/synthesis/agreement");
  return data;
}

// Réinitialiser le questionnaire Valeurs (supprimer résultats et réponses)
export async function resetValeursSurvey() {
  const { data } = await api.delete("/ciaov2_values_survey_user_result");
  return data;
}

// -----------------------------------------------------------------------------
// RIASEC
// -----------------------------------------------------------------------------

// Récupérer les questions du questionnaire RIASEC
export async function getRiasecSurvey() {
  const { data } = await api.get("/ciaov2_riasec_survey");
  return data;
}

// Récupérer les réponses existantes de l'utilisateur (RIASEC)
export async function getRiasecUserAnswers() {
  const { data } = await api.get("/ciaov2_riasec_survey_user");
  return data;
}

// Récupérer le résultat du questionnaire RIASEC (null si pas terminé)
export async function getRiasecUserResult() {
  const { data } = await api.get("/ciaov2_riasec_survey_user_result");
  return data;
}

// Créer une nouvelle réponse RIASEC
export async function createRiasecUserAnswer({ ciaov2_user_id, ciaov2_riasec_survey_id, answer }) {
  const { data } = await api.post("/ciaov2_riasec_survey_user", {
    ciaov2_user_id,
    ciaov2_riasec_survey_id,
    answer
  });
  return data;
}

// Mettre à jour une réponse existante RIASEC
export async function updateRiasecUserAnswer(id, answer) {
  const { data } = await api.patch(`/ciaov2_riasec_survey_user/${id}`, {
    answer
  });
  return data;
}

// Créer le résultat du questionnaire RIASEC (calcul des scores)
export async function createRiasecUserResult() {
  const { data } = await api.post("/ciaov2_riasec_survey_user_result");
  return data;
}

// Générer la synthèse IA du résultat RIASEC
export async function generateRiasecSynthesis() {
  const { data } = await api.post("/ciaov2_riasec_survey_user_result/synthesis");
  return data;
}

// Envoyer l'accord de partage aux parents (RIASEC)
export async function sendRiasecAgreement() {
  const { data } = await api.post("/ciaov2_riasec_survey_user_result/synthesis/agreement");
  return data;
}

// Réinitialiser le questionnaire RIASEC (supprimer résultats et réponses)
export async function resetRiasecSurvey() {
  const { data } = await api.delete("/ciaov2_riasec_survey_user_result");
  return data;
}

// -----------------------------------------------------------------------------
// JOURDA
// -----------------------------------------------------------------------------

// Récupérer les questions du questionnaire Jourda
export async function getJourdaSurvey() {
  const { data } = await api.get("/ciaov2_jourda_survey");
  return data;
}

// Récupérer les réponses existantes de l'utilisateur (Jourda)
export async function getJourdaUserAnswers() {
  const { data } = await api.get("/ciaov2_jourda_survey_user");
  return data;
}

// Récupérer le résultat du questionnaire Jourda (null si pas terminé)
export async function getJourdaUserResult() {
  const { data } = await api.get("/ciaov2_jourda_survey_user_result");
  return data;
}

// Créer une nouvelle réponse Jourda
export async function createJourdaUserAnswer({ ciaov2_user_id, ciaov2_jourda_survey_id, answer }) {
  const { data } = await api.post("/ciaov2_jourda_survey_user", {
    ciaov2_user_id,
    ciaov2_jourda_survey_id,
    answer
  });
  return data;
}

// Mettre à jour une réponse existante Jourda
export async function updateJourdaUserAnswer(id, answer) {
  const { data } = await api.patch(`/ciaov2_jourda_survey_user/${id}`, {
    answer
  });
  return data;
}

// Créer le résultat du questionnaire Jourda (calcul des scores)
export async function createJourdaUserResult() {
  const { data } = await api.post("/ciaov2_jourda_survey_user_result");
  return data;
}

// Générer la synthèse IA du résultat Jourda
export async function generateJourdaSynthesis() {
  const { data } = await api.post("/ciaov2_jourda_survey_user_result/synthesis");
  return data;
}

// Envoyer l'accord de partage aux parents (Jourda)
export async function sendJourdaAgreement() {
  const { data } = await api.post("/ciaov2_jourda_survey_user_result/synthesis/agreement");
  return data;
}

// Réinitialiser le questionnaire Jourda (supprimer résultats et réponses)
export async function resetJourdaSurvey() {
  const { data } = await api.delete("/ciaov2_jourda_survey_user_result");
  return data;
}

// -----------------------------------------------------------------------------
// INTELLIGENCES MULTIPLES (IM)
// -----------------------------------------------------------------------------

// Récupérer les questions du questionnaire IM
export async function getImSurvey() {
  const { data } = await api.get("/ciaov2_im_survey");
  return data;
}

// Récupérer les réponses existantes de l'utilisateur (IM)
export async function getImUserAnswers() {
  const { data } = await api.get("/ciaov2_im_survey_user");
  return data;
}

// Récupérer le résultat du questionnaire IM (null si pas terminé)
export async function getImUserResult() {
  const { data } = await api.get("/ciaov2_im_survey_user_result");
  return data;
}

// Créer une nouvelle réponse IM
export async function createImUserAnswer({ ciaov2_user_id, ciaov2_im_survey_id, answer }) {
  const { data } = await api.post("/ciaov2_im_survey_user", {
    ciaov2_user_id,
    ciaov2_im_survey_id,
    answer
  });
  return data;
}

// Mettre à jour une réponse existante IM
export async function updateImUserAnswer(id, answer) {
  const { data } = await api.patch(`/ciaov2_im_survey_user/${id}`, {
    answer
  });
  return data;
}

// Créer le résultat du questionnaire IM (calcul des scores)
export async function createImUserResult() {
  const { data } = await api.post("/ciaov2_im_survey_user_result");
  return data;
}

// Générer la synthèse IA du résultat IM
export async function generateImSynthesis() {
  const { data } = await api.post("/ciaov2_im_survey_user_result/synthesis");
  return data;
}

// Envoyer l'accord de partage aux parents (IM)
export async function sendImAgreement() {
  const { data } = await api.post("/ciaov2_im_survey_user_result/synthesis/agreement");
  return data;
}

// Réinitialiser le questionnaire IM (supprimer résultats et réponses)
export async function resetImSurvey() {
  const { data } = await api.delete("/ciaov2_im_survey_user_result");
  return data;
}